//@flow
import System from './System';
import t from '../i18n/I18n';
import Environment from './Environment';
import Theme from './Theme';
import ConnectionUtil from '../util/session/ConnectionUtil';
import GetCustomPropsQuery from '../controllers/GetCustomPropsQuery';
import HashMap from '../protocol/HashMap';
import { OsUtil } from './OsUtil';

const debug = require('../debug/debug')('wc:system:Bootstrap');

export default class Bootstrap {
  _system: System;
  appName: string;

  constructor() {
    if (debug.enabled) debug('Starting application: %s with environment: %s', window.ARGS.appName);
    if (debug.enabled) debug('All ENV: %o', process.env);
    this.appName = window.appName ? window.appName : 'WEB_CLIENT';
    this._system = System.getInstance();
    this.setupAppName();
    this.setupEnvironment();
    this.setupTheme();
    Bootstrap.setupBaseURL();
    this.setupNetwork();
    this.setUpCustomisedProps();
  }

  setupAppName(): void {
    this._system.put(System.APP_CODE_KEY, this.appName);
    const appCode: string = this._system.get(System.APP_CODE_KEY, '').toUpperCase();
    let appNameKey = '';
    switch (appCode) {
      case 'WEB':
        appNameKey = System.APP_NAME.WEB;
        break;
      case 'VAB':
        appNameKey = System.APP_NAME.VAB;
        break;
      case 'WEB_CLIENT':
        appNameKey = System.APP_NAME.WEBCLIENT;
        break;
    }
    if (!appNameKey) {
      if (debug.enabled) {
        debug('App code is not passed to the application or wrong value is passed. Aborting the app launch.');
      }
      throw new Error('App code is not passed to the application or wrong value is passed. Aborting the app launch.');
    }
    if (debug.enabled) {
      debug('Setting app name in the System store. App name key: %s. App Name: %s', appNameKey, t(appNameKey));
    }

    this._system.put(System.APP_NAME_KEY, t(appNameKey));
  }

  setupEnvironment(): void {
    const appName = System.getAppName();
    const environment: ?Environment = appName === System.APP_NAME.VAB ? Environment.DESKTOP : Environment.BROWSER;
    if (!environment) {
      if (debug.enabled) debug('Not able to detect any environment. Please make sure environment is passed.');
      throw new Error('Not able to detect any environment. Please make sure environment is passed.');
    }
    this._system.put(System.ENVIRONMENT_KEY, environment);
  }

  setupTheme(): void {
    if (!System.getTheme()) {
      const environment: Environment = System.getEnvironment();
      let theme: Theme = Theme.getTheme();
      if (!theme) {
        if (environment.isBrowser()) {
          theme = Theme.LIGHT;
        } else if (environment.isDesktop()) {
          theme = Theme.DARK;
        }
      }
      if (debug.enabled) debug('Theme setup. Theme: %o', theme);
      this._system.put(System.THEME_KEY, theme);
    }
  }

  static setupBaseURL(): void {
    if (System.isBrowserApp()) {
      window.baseApiUrl = '';
    } else {
      window.baseApiUrl = 'http://127.0.0.1:7770';
    }
  }

  setupNetwork(): void {
    if (debug.enabled) debug('Secure and unsecure call setup');

    let UNSECURE_REMOTE_CALL_URL: string;
    if (System.isBrowserApp()) {
      UNSECURE_REMOTE_CALL_URL = ConnectionUtil.getBaseUrl() + '/webclient/unsecure';
    } else {
      UNSECURE_REMOTE_CALL_URL =
        ConnectionUtil.getBaseUrl() + ConnectionUtil.DESKTOP_CONTEXT + ConnectionUtil.UNSECURE_REMOTE_CALL_SUFFIX;
    }
    this._system.put(ConnectionUtil.UNSECURE_REMOTE_CALL_URL, UNSECURE_REMOTE_CALL_URL);

    let SECURE_REMOTE_CALL_URL: string;
    if (System.isBrowserApp()) {
      SECURE_REMOTE_CALL_URL = ConnectionUtil.getBaseUrl() + '/webclient/vabremoting/';
    } else {
      SECURE_REMOTE_CALL_URL =
        ConnectionUtil.getBaseUrl() + ConnectionUtil.DESKTOP_CONTEXT + ConnectionUtil.SECURE_REMOTE_CALL_SUFFIX;
    }

    this._system.put(ConnectionUtil.SECURE_REMOTE_CALL_URL, SECURE_REMOTE_CALL_URL);
  }

  setUpCustomisedProps() {
    if (System.isDesktop()) {
      new GetCustomPropsQuery().run().then(
        (resp) => {
          //FAV_ICON //HOME_HEADER //LOGO  //LOGIN_BG
          const items: HashMap = resp.getResponseMap();
          console.log(items, typeof items);
          if (items.size) {
            if (items.containsKey('HOME_HEADER'))
              window.homeHeaderExists = OsUtil.isMAC() ? items.get('HOME_HEADER') : new URL(items.get('HOME_HEADER'));
            if (items.containsKey('LOGO'))
              window.logoExists = OsUtil.isMAC() ? items.get('LOGO') : new URL(items.get('LOGO'));
            if(items.containsKey('LOGIN_OVERLAY'))
              window.loginOverlay = JSON.parse(items.get('LOGIN_OVERLAY'));
            if (items.containsKey('LOGIN_BG'))
              window.loginBgExists = OsUtil.isMAC() ? items.get('LOGIN_BG') : new URL(items.get('LOGIN_BG'));
              window.gs.updateNotLoggedInBlock ? window.gs.updateNotLoggedInBlock() : null;
          }
          if (debug.enabled) {
            debug('getcustom query response');
            debug(resp);
          }
        },
        (error) => {
          if (debug.enabled) {
            debug('getcustom query error');
            debug(error);
          }
        }
      );
    }
  }
}
